/**
 * 臻有钱-品质首页- 产品入口 - 通过广告投放系统接入 https://fat-admaster.hellobike.cn/#/ssp/operation-mng
 * 广告位信息
 * 名称:数科-臻有钱首页-入口九宫格
 * uuid: d8d5fd5d50de4e28a9dc94dcc0378765
 *
 * 金刚位
 */
import { Vue, Component } from 'vue-property-decorator';
import {
  openInnerPage,
  openThirdPage,
} from '@/api/native/utils';
import platform from '@/shared/utils/platform';
import { skNativeContainer } from '@/api/native/container';
import RouterHelper from '@/shared/utils/routerHelper';
import store from '@/store';
import { openWithNewWebview } from '@/shared/utils/jumpTo';
import { financeWeiXinMpUrlScheme } from '@/constant';
import wechat from '@/api/native/wechat';
import AdvCommonContainer from '../adv-common-container';
import { AdvEvent } from '../types';

import style from './index.module.scss';

 @Component
export default class AdvProductList extends Vue {
  /** 点击埋点 */
  private ubtClickTrack(event:AdvEvent) {
    const { item } = event.data.dataset || {};


    this.$ubtPageButton('finance_product_newIcon',
      'task_name',
      item.tracker.child_task_name);
    if (item.link.includes('AppFinanceLoanH5')) {
      if ((platform.isAndroid || platform.isHarmony) && platform.isHelloApp) {
        openInnerPage(item.link);
      } else {
        RouterHelper.tabbarStatusHandler(item.link);
        if (openWithNewWebview(item.link)) {
          openInnerPage(item.link);
        } else {
          let newUrl = item.link;
          if (store.state.base.isHybridAppMode) {
            newUrl = `${item.link}${item.link.includes('?') ? '&' : '?'}hybridAppMode=1`;
          }
          window.location.href = newUrl;
        }
      }
    } else if (item.ext?.jumpConfig) {
      /**
       * 设置customClickConfirm=true时，广告系统不会处理跳转，需要自己处理跳转
       * 若是配置是'微信小程序'模式 jumpConfig对象有小程序的appid、path
       * userName: 小程序的appid
       * path: 小程序页面page?参数，如：/pages/index/index?id%3D123&name%3Dhello
       */
      const { userName, path } = item.ext.jumpConfig || {};

      if (userName && path) {
        const [page, query] = String(path).split('?');

        window.location.href = `${financeWeiXinMpUrlScheme.replace(wechat.appId, userName)}&path=${page}&query=${query}`;
      }
    } else {
      openThirdPage(item.link);
    }
  }

  private show() {
    // 组件显示
    this.$ubtModuleExpose('finance_product_newIcon');
  }


  private render() {
    return (
      <AdvCommonContainer
        advMasterId="d8d5fd5d50de4e28a9dc94dcc0378765"
        onClickEmitter={this.ubtClickTrack.bind(this)}
        onLoad={this.show.bind(this)}
        customClassName={style.advProductList}
        customClickConfirm="true"
      />
    );
  }
}
